const SearchedError = ({text}) => {
  return (
    <div className='searched-error'>
      <h1>
        {text}
      </h1>
    </div>
  );
};

export default SearchedError;
